export enum AccessPointProcessingGroup {

  MedicareAdvantage = "Medicare Advantage",
  Other = "Other",
  Address = "Address",
  TaxId = "Tax Id",
}
